/* Publish by EComposer at 2026-10-18 13:00:04*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-azzh8rh5man"]=  window.__ectimmers["ecom-azzh8rh5man"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-azzh8rh5man').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-azzh8rh5man', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9cgiaz0y22p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9cgiaz0y22p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mpo2x5u5pa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mpo2x5u5pa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bpmt1ikrcam').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bpmt1ikrcam', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608011').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608011', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608017').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608017', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608019').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608019', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608039').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608039', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608045').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608045', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608047').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608047', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uvbn3xz77i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uvbn3xz77i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-50yvry5fyuc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-50yvry5fyuc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s72gwjbf4fg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s72gwjbf4fg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k3npjr9z1ts').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k3npjr9z1ts', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tz6crdqifm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tz6crdqifm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jj3jydicefd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jj3jydicefd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ruqcbty3chp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ruqcbty3chp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c4blcc1j3j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4blcc1j3j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ohburvvs07d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ohburvvs07d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-867a4671fc5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-867a4671fc5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3611859e482').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3611859e482', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c4bb6eb3766').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4bb6eb3766', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85698e9e886').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85698e9e886', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0b53c67d4bd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0b53c67d4bd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-445d0ae522f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-445d0ae522f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b41fb0e9958').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b41fb0e9958', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d894d60fac4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d894d60fac4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ea1148f35a5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ea1148f35a5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fvgf8uvkf38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fvgf8uvkf38', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xb4aq6bxiu8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xb4aq6bxiu8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e076f1ebbeb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e076f1ebbeb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-506999de698').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-506999de698', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfx2j6vf9o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfx2j6vf9o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2fprj2jmkbn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2fprj2jmkbn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wx29oboohrj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wx29oboohrj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600141').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600141', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600147').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600147', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600149').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600149', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600165').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600165', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600171').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600171', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600173').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600173', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600189').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600189', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600195').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600195', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600197').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600197', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l9rsohywb6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l9rsohywb6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1k234qyq1t3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1k234qyq1t3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kr7prt51i2k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kr7prt51i2k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-na3zn56oi2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-na3zn56oi2b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ped2q5fbsjl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ped2q5fbsjl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ttwkazattk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ttwkazattk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rnm1en8byv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rnm1en8byv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36ba9d7a43d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36ba9d7a43d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ff55dccb780').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ff55dccb780', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-67c388bd73f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-67c388bd73f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6eb85b080fe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6eb85b080fe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f8c741f8acb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f8c741f8acb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2003279a271').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2003279a271', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7a5bd98c94c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7a5bd98c94c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7fa0d4bf934').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7fa0d4bf934', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k1hn8327vwo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k1hn8327vwo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m2qgkuufbhf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m2qgkuufbhf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5l9jv2c2ak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5l9jv2c2ak', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pdi491hxlcf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdi491hxlcf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ivoyzty4de').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ivoyzty4de', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ut5tg3lov7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ut5tg3lov7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1hqrfnkqgog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1hqrfnkqgog', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mpok5vcuwhl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mpok5vcuwhl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xdwn3a4ro2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdwn3a4ro2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uikyz3svmqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uikyz3svmqj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mj7pkx4jf4a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mj7pkx4jf4a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ztdyuorulem').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ztdyuorulem', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f3020522dd6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f3020522dd6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4e044a036cc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4e044a036cc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-096153d89fb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-096153d89fb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3330df1f46').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3330df1f46', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fc14fd25953').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fc14fd25953', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-325d851681d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-325d851681d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dd6eed172d8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dd6eed172d8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-193e292f23c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-193e292f23c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-igluacx7if').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-igluacx7if', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-19sxj8b1b5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-19sxj8b1b5d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5zz8dzhr3il').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5zz8dzhr3il', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pbzhaseytt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pbzhaseytt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iwjfsryo9c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iwjfsryo9c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600327').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600327', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600329').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600329', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37nqr08d70e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37nqr08d70e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2f4fjfx0the').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2f4fjfx0the', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-100c51efca1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-100c51efca1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-86bf3860be1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-86bf3860be1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vgror6xdwsn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vgror6xdwsn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3v83ozcbix5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3v83ozcbix5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yfr7omu07mc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yfr7omu07mc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eg1q46hybv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eg1q46hybv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3o5dvhr06ut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3o5dvhr06ut', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mg3e089ko1c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mg3e089ko1c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c85qsaqm68o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c85qsaqm68o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y28074mksx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y28074mksx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zg7jacyudp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zg7jacyudp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sugd2iuwnz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sugd2iuwnz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7e41h4xjhw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7e41h4xjhw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a35dp2a7mi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a35dp2a7mi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uaoiyzv3op').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uaoiyzv3op', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jpuip6fxcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jpuip6fxcm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p410uxqvv1h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p410uxqvv1h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wg81b9srb6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wg81b9srb6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23f0n3pdcdz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23f0n3pdcdz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-re5rq9ub2z9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-re5rq9ub2z9', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7qa4502din6"]=  window.__ectimmers["ecom-7qa4502din6"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-7qa4502din6"]["8gtqetzsj"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-7qa4502din6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7qa4502din6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hp9auy9caxi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hp9auy9caxi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mqeyye1xtch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mqeyye1xtch', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5lcv0rno7co').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5lcv0rno7co', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9p4djm1moo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9p4djm1moo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y3qki22veer').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y3qki22veer', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bf5uyzjbvch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bf5uyzjbvch', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3rne0ibpmox').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3rne0ibpmox', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608021').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608021', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l42bvgcem8q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l42bvgcem8q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608049').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608049', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mlsd3cewmfh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mlsd3cewmfh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0on6w20qw1ob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0on6w20qw1ob', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nt0tv3mk0f8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nt0tv3mk0f8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9qwcyk0hfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9qwcyk0hfq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mickqe55r8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mickqe55r8p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r8stk4w75ln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r8stk4w75ln', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-idx36igy1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-idx36igy1r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600151').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600151', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600175').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600175', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600199').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600199', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-938ovk8ls5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-938ovk8ls5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a8508600023').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a8508600023', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b1e89624613').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b1e89624613', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14c8546f876').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14c8546f876', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-64e55451399').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-64e55451399', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-voce2cx7x58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-voce2cx7x58', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qxa9of7i2x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qxa9of7i2x', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600331').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600331', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gjpqckciwqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gjpqckciwqn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-50uyntbd109').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-50uyntbd109', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdt13c5y1ae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdt13c5y1ae', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cqr1xkbt4yh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cqr1xkbt4yh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v0ggs5pj1es').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v0ggs5pj1es', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zfsmp7kjbns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zfsmp7kjbns', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0h7jeih50tye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0h7jeih50tye', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2pvt5uu1om4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2pvt5uu1om4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmea6g0b7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmea6g0b7h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28ef1zzzsk2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28ef1zzzsk2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cr3tegih1ft').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cr3tegih1ft', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzd2r6ew6fk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzd2r6ew6fk', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fmw2608009"]=  window.__ectimmers["ecom-fmw2608009"] || {};
var o,n;let t=this.$el;if(!t)return;let e=t.querySelector("afterpay-placement.ecom-afterpay-integrate"),i=this.$el.closest(".ecom-product-form--single");if(i){let r=i.querySelector('[name="id"]');if(r&&r.dispatchEvent(new window.Event("ecomUpdate")),this.settings.show_total_price){const a=i.querySelector(".ecom-product-single__quantity-input"),l=t.querySelector(".ecom-product-single__price--sale");if(!l)return;a&&a.addEventListener("change",function(){l.innerHTML=window.EComposer.formatMoney(parseInt(l.getAttribute("data-price"))*parseInt(this.value))}),i.addEventListener("ecomVariantChange",function(c){if(c.detail.variant){const d=c.detail.variant,p=a?parseInt(a.value):1;l.setAttribute("data-price",d.price),p>1&&(l.innerHTML=window.EComposer.formatMoney(d.price*parseInt(p)))}})}}if(this.settings.enable_afterpay){let r=window.document.querySelector("#ecom-after-pay-script");if(window.afterpay_min=this.settings.lower_limit||1,r)r.dataset.analyticsEnabled=!0,r.dataset.min=(o=this.settings.lower_limit)!=null?o:1,r.dataset.max=(n=this.settings.upper_limit)!=null?n:1e3;else{let a=window.document.createElement("script");a.id="ecom-after-pay-script",a.dataset.analyticsEnabled=!0,a.dataset.min=this.settings.lower_limit||1,a.dataset.max=this.settings.upper_limit||1e3,a.src="https://js.afterpay.com/afterpay-1.x.js",window.document.head.appendChild(a)}e&&this.isLive&&window.jQuery&&window.Afterpay&&window.Afterpay.initProductPage&&window.Afterpay.initProductPage(window.jQuery)}let s=t.querySelector(".ecom-product-single__price--badges-sale");if(s&&s.dataset.haveSale=="true"){let r=s.dataset.sale,a=s.dataset.text;a=a.replace(/\{.*\}/g,r),s.innerHTML=a,s.style.display="block"}

                    });
                    
                        document.querySelectorAll('.ecom-fmw2608009').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608009', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608037').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608037', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600139').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600139', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600163').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600163', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600187').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600187', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-692afb5016f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-692afb5016f', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ff81fff19ac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ff81fff19ac', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2ed5bbd9c9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2ed5bbd9c9', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3da473806d4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3da473806d4', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600321').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600321', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3hwzwsq0jnq"]=  window.__ectimmers["ecom-3hwzwsq0jnq"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-3hwzwsq0jnq"]["upt55uiqo"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-3hwzwsq0jnq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3hwzwsq0jnq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-60b9m503w0m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-60b9m503w0m', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608013').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608013', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2608041').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2608041', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5fz3q3kza7u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5fz3q3kza7u', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-054e8d797b2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-054e8d797b2', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ce0c691e3f1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ce0c691e3f1', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-26aec392ae4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-26aec392ae4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-38abdcfab1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-38abdcfab1d', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4960b693bda').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4960b693bda', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a9ff81e03f2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a9ff81e03f2', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4c98a610dbb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4c98a610dbb', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600143').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600143', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600167').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600167', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600191').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600191', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-885d314a645').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-885d314a645', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5f97fb707c4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5f97fb707c4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-219da8738fd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-219da8738fd', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-585a57dcdbb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-585a57dcdbb', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3l2rses00k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3l2rses00k', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d243c335ff7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d243c335ff7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-38f045ecabc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-38f045ecabc', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5c477c31eac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5c477c31eac', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f09dbbeb520').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f09dbbeb520', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fcdd3850bdd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fcdd3850bdd', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k9ouo5k0ixa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9ouo5k0ixa', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmw2600323').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmw2600323', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0f90inqnsjib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0f90inqnsjib', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a8jfc5zh106').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a8jfc5zh106', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0f2fbfd7eab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0f2fbfd7eab', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nv1n0j3gqlk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nv1n0j3gqlk', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aps6inst968').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aps6inst968', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0czp5k53dfm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0czp5k53dfm', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ns9bulkuueq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ns9bulkuueq', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ey08sk0z41p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ey08sk0z41p', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ma60wo6k7n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ma60wo6k7n', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-f9g7c6pdb6"]=  window.__ectimmers["ecom-f9g7c6pdb6"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,s=this.settings.autoplay,o=this.settings.lazyload||!1,n=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const p=t.querySelector(".ecom-video-poster");let m;m=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");o&&setTimeout(function(){b(_)},500);function b(A){let j={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,j).observe(A)}function y(A,j){let P={handleMouseenter:T,handleMouseleave:I,handleEnded:D};function T(){A.readyState>=c&&A.pause()}function I(){A.readyState>=c&&A.play()}function D(){v(A,P)}if(r){A.addEventListener("mouseenter",T),A.addEventListener("mouseleave",I);let R=t.querySelector(".ecom-video_link-extra");R&&R.href&&(R.addEventListener("mouseenter",T),R.addEventListener("mouseleave",I)),j||A.addEventListener("ended",D)}}function v(A,j){if(j){const{handleMouseenter:P,handleMouseleave:T,handleEnded:I}=j;let D=t.querySelector(".ecom-video_link-extra");A.removeEventListener("mouseenter",P),A.removeEventListener("mouseleave",T),A.removeEventListener("ended",I),D&&D.href&&(D.removeEventListener("mouseenter",P),D.removeEventListener("mouseleave",T))}}function w(A,j){A.forEach(function(P){if(P.isIntersecting){const T=P.target.querySelector("video source"),I=P.target.querySelector("video"),D=P.target.querySelector("iframe");if(I&&T&&(T.src=T.dataset.source,I.load(),I.addEventListener("loadeddata",function(){s&&I.play()})),D){let R=D.dataset.srcVideo;D.setAttribute("src",R)}j.unobserve(P.target)}})}let S=t.querySelector(".ecom_video"),C=t.querySelector(".ecom_iframe");a&&S&&S.addEventListener("click",()=>{S.readyState>=c&&(S.paused?S.play():S.pause())}),s&&(d&&d.classList.remove("ecom-overlay"),m&&(m.style.display="none"),p&&(p.style.display="none")),S&&!i&&S.addEventListener("ended",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&S)p&&(p.style.display="none"),S.autoplay=!0,S.play(),d.classList.remove("ecom-overlay"),m.style.display="none";else if(C){let A=C.getAttribute("src");A.includes("autoplay=0")?A=A.replace("autoplay=0","autoplay=1"):A=A+"&autoplay=1",C.setAttribute("src",A),l?setTimeout(()=>{A=A.replace("autoplay=1","autoplay=0"),C.setAttribute("src",A)},100):(p&&(p.style.display="none"),d.classList.remove("ecom-overlay"),m.style.display="none")}}),S&&(e&&!p&&y(S,i),p&&p.addEventListener("click",function(){p.style.display="none",S.play(),e&&y(S,i)}),r||S.addEventListener("pause",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),!n&&d&&S.addEventListener("click",function(){S.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function(A){A.dataset.ecTrackingId&&A.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:A.id,tracking_id:A.dataset.ecTrackingId})},{once:!0})});const x=t.querySelector("[ecom-modal]"),$=function(A){if(window.EComModal)return A();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&A()});return}let j=0;const P= window.__ectimmers["ecom-f9g7c6pdb6"]["qps7v5y8i"] = setInterval(function(){window.EComModal?(clearInterval(P),A()):++j>=300&&clearInterval(P)},50)},E=this.id;x&&this.settings.image_overlay&&l&&$(function(){const A=x.dataset.width,j=x.dataset.height;var P=E;new window.EComModal(x,{cssClass:[P,"ecom-core","ecom-core-simulator"],onOpen:function(){var T=document.querySelector(".ecom-modal."+P);if(T){const I=T.querySelector(".ecom-modal-box__content");I.classList.add("ecom-element_video-iframe");const D={width:A,height:j};Object.assign(I.style,D)}},onClose:function(){var T=document.querySelector(".ecom-modal."+P);if(T){const I=T.querySelector(".ecom-element_video-iframe iframe");I&&(I.src="")}}})})

                    });
                    
                        document.querySelectorAll('.ecom-f9g7c6pdb6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f9g7c6pdb6', settings: {"loop":false,"autoplay":false,"player_controls":true,"click_to_play_pause":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3tcvtwlfuky').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3tcvtwlfuky', settings: {"loop":false,"autoplay":false,"player_controls":true,"click_to_play_pause":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}